import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";

const TrainingSection = () => (
    <ScrollableAnchor id="training">
      <section className="content-section bg-primary text-white text-center animatedParent animateOnce" data-sequence='500' data-appear-top-offset='-300'>
        <div className="container">
          <div className="content-section-heading text-center">
            <h3 className="text-secondary mb-0">Info</h3>
            <h2 className="mb-5">Funktionstraining</h2>
          </div>
          <div className="animated fadeInDownShort" data-id="1">
            <p className="textJustify">Spezielle Übungen dienen dazu, die kranken sowie gesunden Gelenke in ihren Funktionen beweglich
              zu halten, sie zu fördern ohne sie zu überfordern. Funktionstraining findet als Trockengymnastik statt und
              wird durch den Therapeuten individuell gefördert. Das Training ist geeignet für Orthopädische Leiden (Rehabilitation),
              Prävention und Leistungssport. Es kann über das "Formular 56" (Rehasport) von den Krankenkassen bezahlt werden oder über die "Flexikart"
              Selbstzahler durchgeführt werden.</p>
          </div>
        </div>
      </section>
    </ScrollableAnchor>
);

export default TrainingSection;



// WEBPACK FOOTER //
// ./src/courseinfo/training.js